<script setup>
import { computed } from 'vue';
import { trans } from '@elements/translation';
import { OfficeStateEnum } from '@organisms/offer/office-state-enum';

const props = defineProps({
  offer: {
    type: Object,
    required: true,
  },
});

const state = computed(() => props.offer.state);

const cleanState = computed(() => {
  if (state.value.includes('setup_')) {
    return 'setup';
  }
  const validStates = [
    OfficeStateEnum.PUBLISHED,
    OfficeStateEnum.UNPUBLISHED,
    OfficeStateEnum.BLOCKED,
    OfficeStateEnum.MODERATION,
    OfficeStateEnum.OFFMARKET,
    OfficeStateEnum.EXPIRED,
  ];
  return validStates.includes(state.value) ? state.value : null;
});

const show = computed(() => !!cleanState.value);
</script>
<template>
  <span v-if="show" class="hit-label hit-label--state" :class="`hit-label--state_${cleanState}`">
    {{ trans(`offer.label.${cleanState}`) }}
  </span>
</template>
